import { render, staticRenderFns } from "./OverallPlan_phone.vue?vue&type=template&id=f5a52b4e&scoped=true&"
import script from "./OverallPlan_phone.vue?vue&type=script&lang=js&"
export * from "./OverallPlan_phone.vue?vue&type=script&lang=js&"
import style0 from "./OverallPlan_phone.vue?vue&type=style&index=0&id=f5a52b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a52b4e",
  null
  
)

export default component.exports